import { useCreateBankTransaction } from 'api-hooks/transactions/bank-transaction';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { NavigationProps } from 'types';

import { BankTransactionForm } from './components/form';

export type BankTransactionsCreateParams = null;

export default function BankTransactionsCreate(
  props: NavigationProps<NavigationRoutes.BankTransactionsCreate>,
) {
  const { mutateAsync, error } = useCreateBankTransaction();

  const onResolve = useApprovalableEdit('bank-transactions');

  return (
    <>
      {!!error && !!error.message && (
        <>
          <Notification
            overrides={{
              Body: { style: { width: 'auto', wordBreak: 'break-all' } },
            }}
            kind={KIND.negative}
            closeable
          >
            {() => error.message}
          </Notification>
        </>
      )}
      <BankTransactionForm
        {...props}
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);
          onResolve(result);
          return result.data;
        }}
      />
    </>
  );
}
